
const threeLoader = {
    state: {
        loader: null
    },
    getters: {},
    mutations: {
        SET_THREE_LOADER: (state, data) => {
            state.loader = data
        }
    },
    actions: {

    }
}
export default threeLoader
